// extracted by mini-css-extract-plugin
export default {"Grid":"styles_Grid__ll9Ch","gridTableStyle":"styles_gridTableStyle__uSu1E","bodyStyle":"styles_bodyStyle__KYEIm","rowStyle":"styles_rowStyle__3CmsX"};